import React, { useRef, useState } from "react";
import {
  BreadcrumbGroup,
  ContentLayout,
  Header,
} from "@amzn/awsui-components-react";
import {
  CustomAppLayout,
  Navigation,
  Notifications,
} from "../commons/common-components";
import { uploadFilesBreadcrumbs } from "./uploadfilescommon/breadcrumbs";
import { FormContent } from "./uploadfilescomponents/form-content";
import "../styles/form.scss";
import { Analytics } from "aws-amplify";
import { AppLayout } from "../components/Layout";

Analytics.autoTrack("pageView", {
  // REQUIRED, turn on/off the auto tracking
  enable: true,
  // OPTIONAL, the event name, by default is 'pageView'
  eventName: "UploadPage",
  type: "SPA",
  getUrl: () => {
    // the default function
    return window.location.origin + window.location.pathname;
  },
});

const Breadcrumbs = () => (
  <BreadcrumbGroup
    items={uploadFilesBreadcrumbs}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs"
  />
);

function FormHeader() {
  return (
    <Header variant="h1" description="Please fill out the following fields.">
      Upload File(s)
    </Header>
  );
}

const UploadFilesPage = () => {
  const appLayout = useRef();

  return (
    <AppLayout
      content={
        <div className="content-wrapper">
          <FormContent loadHelpPanelContent={""} />
        </div>
      }
      breadcrumbs={uploadFilesBreadcrumbs}
    />
  );
};

export { UploadFilesPage };
